module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    staticClass: "touch-item",
    attrs: {
      "pan-options": {
        direction: 'horizontal',
        threshold: 0
      }
    },
    on: {
      "panend": _vm.onPanEnd,
      "panmove": _vm.onPanMove
    }
  }, [_c('div', {
    staticClass: "item-c"
  }, [_c('menu-button'), _vm._v(" "), _c('div', {
    staticClass: "item",
    style: ({
      transform: 'translate(' + _vm.offsetX + 'px)'
    }),
    on: {
      "click": _vm.modifyCard
    }
  }, [_c('p', {
    staticClass: "p-title"
  }, [_vm._v("记录日记")]), _vm._v(" "), _c('p', {
    staticClass: "p-desc"
  }, [_vm._v("定义离开过渡的结束状态定义。在离开过渡被触发时生效")]), _vm._v(" "), _c('div', {
    staticClass: "num-tip"
  }, [_vm._v("3")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a69dc11c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/touchItem.vue
// module id = 53
// module chunks = 0